<div class="cad">
  <header class="cad-head">
    <div>
      <h2>Cadastral · Right of Way</h2>
      <p class="hint">Land parcels along {{ route?.route_code }} with compensation, permissions, relocation &amp; disputes.</p>
    </div>
    <button type="button" class="btn secondary sm" (click)="reload()" [disabled]="loading">Refresh</button>
  </header>

  <div class="cad-kpis" *ngIf="summary">
    <div class="kpi" *ngFor="let s of parcelStatuses" [style.borderColor]="statusMeta[s].color">
      <span class="kpi-label">{{ statusMeta[s].label }}</span>
      <strong>{{ summary.parcels[s].count }}</strong>
      <small>{{ summary.parcels[s].area_ha | number: '1.0-2' }} ha</small>
    </div>
  </div>
  <div class="acq-bar" *ngIf="summary && summary.total_parcels">
    <div class="acq-fill" [style.width.%]="summary.acquired_pct"></div>
    <span>{{ summary.acquired_pct }}% of {{ summary.total_area_ha | number: '1.0-2' }} ha acquired</span>
  </div>

  <nav class="cad-tabs">
    <button type="button" *ngFor="let t of tabs" [class.active]="tab === t.id" (click)="setTab(t.id)">{{ t.label }}</button>
  </nav>

  <p class="cad-msg ok" *ngIf="message">{{ message }}</p>
  <p class="cad-msg err" *ngIf="error">{{ error }}</p>

  <!-- Land parcels -->
  <ng-container *ngIf="tab === 'parcels'">
    <div class="toolbar">
      <select [(ngModel)]="statusFilter" name="statusFilter">
        <option value="">All statuses</option>
        <option *ngFor="let s of parcelStatuses" [value]="s">{{ statusMeta[s].label }}</option>
      </select>
      <button type="button" class="btn primary sm" *ngIf="canEdit && !parcelForm" (click)="newParcel()">+ New parcel</button>
    </div>

    <form class="cad-form" *ngIf="parcelForm" (ngSubmit)="saveParcel()">
      <h3>{{ parcelForm.id ? 'Edit parcel' : 'New parcel' }}</h3>
      <div class="grid2">
        <label>Parcel code *<input [(ngModel)]="parcelForm.parcel_code" name="parcel_code" required /></label>
        <label>Survey no.<input [(ngModel)]="parcelForm.survey_no" name="survey_no" /></label>
        <label>Owner<input [(ngModel)]="parcelForm.owner_name" name="owner_name" /></label>
        <label>Status
          <select [(ngModel)]="parcelForm.status" name="status">
            <option *ngFor="let s of parcelStatuses" [value]="s">{{ statusMeta[s].label }}</option>
          </select>
        </label>
        <label>Land use<input [(ngModel)]="parcelForm.land_use" name="land_use" placeholder="agricultural" /></label>
        <label>Zoning<input [(ngModel)]="parcelForm.zoning" name="zoning" placeholder="rural" /></label>
        <label>Side
          <select [(ngModel)]="parcelForm.side" name="side">
            <option value="">—</option>
            <option value="L">Left</option>
            <option value="R">Right</option>
            <option value="BOTH">Both</option>
          </select>
        </label>
        <label>Area (ha)<input type="number" step="0.0001" [(ngModel)]="parcelForm.area_ha" name="area_ha" placeholder="auto from polygon" /></label>
      </div>
      <label>Remarks<textarea rows="2" [(ngModel)]="parcelForm.remarks" name="remarks"></textarea></label>

      <div class="geom-row">
        <span class="geom-label">Boundary</span>
        <button type="button" class="btn sm" [class.primary]="drawActive" [class.secondary]="!drawActive" (click)="toggleDraw()">
          {{ drawActive ? 'Drawing… click map (double-click to finish)' : 'Draw polygon on map' }}
        </button>
        <span class="geom-ok" *ngIf="geometryText">✓ geometry set</span>
      </div>
      <label>GeoJSON (Polygon / Feature, EPSG:4326)
        <textarea rows="3" class="mono" [(ngModel)]="geometryText" name="geometryText" placeholder='{"type":"Polygon","coordinates":[...]}'></textarea>
      </label>

      <div class="actions">
        <button type="submit" class="btn primary sm">Save parcel</button>
        <button type="button" class="btn secondary sm" (click)="cancelParcel()">Cancel</button>
        <button type="button" class="btn danger sm" *ngIf="parcelForm.id" (click)="deleteParcel(parcelForm)">Delete</button>
      </div>
    </form>

    <div class="table-wrap">
      <table class="cad-table" *ngIf="filteredParcels.length; else noParcels">
        <thead>
          <tr>
            <th>Code</th>
            <th>Owner</th>
            <th>Area ha</th>
            <th>Status</th>
            <th>Use / zone</th>
            <th>Km</th>
            <th>Comp. paid</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of filteredParcels" [class.selected]="p.id === selectedParcelId" (click)="selectParcel(p)">
            <td><strong>{{ p.parcel_code }}</strong><small *ngIf="p.survey_no">{{ p.survey_no }}</small></td>
            <td>{{ p.owner_name || '—' }}</td>
            <td>{{ p.area_ha != null ? (p.area_ha | number: '1.0-3') : '—' }}</td>
            <td>
              <span class="pill" [style.background]="statusMeta[p.status].color">{{ statusMeta[p.status].label }}</span>
              <span class="dispute-flag" *ngIf="p.open_disputes" title="Open disputes">⚑ {{ p.open_disputes }}</span>
            </td>
            <td>{{ p.land_use || '—' }}<small *ngIf="p.zoning">{{ p.zoning }}</small></td>
            <td>{{ km(p.from_measure_m) }}<small *ngIf="p.to_measure_m != null">→ {{ km(p.to_measure_m) }}</small></td>
            <td>{{ inr(p.compensation_paid) }}<small>of {{ inr(p.compensation_total) }}</small></td>
            <td class="row-actions" (click)="$event.stopPropagation()">
              <button type="button" class="link" *ngIf="canEdit" (click)="editParcel(p)">Edit</button>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #noParcels>
        <p class="empty">{{ loading ? 'Loading parcels…' : 'No land parcels on this route yet.' }}</p>
      </ng-template>
    </div>

    <section class="parcel-drawings" *ngIf="selectedParcel as sp">
      <app-cad-drawing-list
        contextType="lrs_cadastral"
        [contextId]="sp.id"
        [projectId]="routeProjectId"
        [title]="'Drawings · ' + sp.parcel_code"
        [canEdit]="canEdit"
        [compact]="true"
      ></app-cad-drawing-list>
    </section>
  </ng-container>

  <!-- Compensation / Permissions / Utility relocation / Disputes -->
  <ng-container *ngIf="activeRecordForm as def">
    <div class="toolbar">
      <select [(ngModel)]="recordParcelFilter" name="recordParcelFilter" (ngModelChange)="loadRecords()">
        <option [ngValue]="null">{{ def.routeLevel ? 'Whole route' : 'All parcels' }}</option>
        <option *ngFor="let p of parcels" [ngValue]="p.id">{{ p.parcel_code }} · {{ p.owner_name || '—' }}</option>
      </select>
      <button type="button" class="btn primary sm" *ngIf="canEdit && !recordForm" (click)="newRecord()">+ Add</button>
    </div>

    <form class="cad-form" *ngIf="recordForm" (ngSubmit)="saveRecord()">
      <h3>{{ recordForm['id'] ? 'Edit' : 'New' }} {{ def.label | lowercase }}</h3>
      <div class="grid2">
        <label>{{ def.routeLevel ? 'Linked parcel' : 'Parcel *' }}
          <select [(ngModel)]="recordForm['parcel_id']" name="parcel_id" [disabled]="!!recordForm['id'] && !def.routeLevel">
            <option [ngValue]="null">{{ def.routeLevel ? '— none —' : 'Select parcel' }}</option>
            <option *ngFor="let p of parcels" [ngValue]="p.id">{{ p.parcel_code }}</option>
          </select>
        </label>
        <label>Status
          <select [(ngModel)]="recordForm['status']" name="status">
            <option *ngFor="let s of def.statuses" [value]="s">{{ label(s) }}</option>
          </select>
        </label>
        <ng-container *ngFor="let fd of def.fields">
          <label *ngIf="fd.type !== 'textarea'">{{ fd.label }}{{ fd.required ? ' *' : '' }}
            <input
              [type]="fd.type === 'km' ? 'number' : fd.type"
              [step]="fd.type === 'km' ? '0.001' : 'any'"
              [(ngModel)]="recordForm[fd.key]"
              [name]="fd.key"
            />
          </label>
        </ng-container>
      </div>
      <ng-container *ngFor="let fd of def.fields">
        <label *ngIf="fd.type === 'textarea'">{{ fd.label }}
          <textarea rows="2" [(ngModel)]="recordForm[fd.key]" [name]="fd.key"></textarea>
        </label>
      </ng-container>
      <div class="actions">
        <button type="submit" class="btn primary sm">Save</button>
        <button type="button" class="btn secondary sm" (click)="recordForm = null">Cancel</button>
      </div>
    </form>

    <div class="table-wrap">
      <table class="cad-table" *ngIf="records.length; else noRecords">
        <thead>
          <tr>
            <th>Parcel</th>
            <th *ngFor="let fd of tableFields(def)">{{ fd.label }}</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of records">
            <td>{{ r.parcel_code || '—' }}</td>
            <td *ngFor="let fd of tableFields(def)">{{ displayValue(r, fd) }}</td>
            <td><span class="status-tag" [attr.data-status]="r.status">{{ label(r.status) }}</span></td>
            <td class="row-actions">
              <ng-container *ngIf="canEdit">
                <button type="button" class="link" (click)="editRecord(r)">Edit</button>
                <button type="button" class="link danger" (click)="deleteRecord(r)">Delete</button>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-template #noRecords>
        <p class="empty">No {{ def.label | lowercase }} records{{ recordParcelFilter ? ' for this parcel' : '' }}.</p>
      </ng-template>
    </div>
  </ng-container>

  <!-- Land reports -->
  <ng-container *ngIf="tab === 'reports'">
    <div class="report-cards" *ngIf="summary">
      <div class="rcard">
        <span>Acquired</span>
        <strong>{{ summary.parcels.owned.area_ha | number: '1.0-2' }} ha</strong>
        <small>{{ summary.acquired_pct }}% of corridor land</small>
      </div>
      <div class="rcard">
        <span>Under process</span>
        <strong>{{ summary.parcels.under_process.area_ha | number: '1.0-2' }} ha</strong>
        <small>{{ summary.parcels.under_process.count }} parcels</small>
      </div>
      <div class="rcard warn">
        <span>Pending / disputed</span>
        <strong>{{ (summary.parcels.pending.area_ha + summary.parcels.disputed.area_ha) | number: '1.0-2' }} ha</strong>
        <small>{{ summary.parcels.pending.count + summary.parcels.disputed.count }} parcels</small>
      </div>
      <div class="rcard">
        <span>Compensation</span>
        <strong>{{ inr(summary.compensation_paid) }}</strong>
        <small>paid of {{ inr(summary.compensation_total) }}</small>
      </div>
      <div class="rcard">
        <span>Open disputes</span>
        <strong>{{ statusCount(summary.disputes, ['open', 'hearing']) }}</strong>
        <small>{{ statusCount(summary.permissions, ['granted']) }} permissions granted</small>
      </div>
      <div class="rcard">
        <span>Utility relocation</span>
        <strong>{{ statusCount(summary.utility_relocations, ['completed']) }} / {{ statusCount(summary.utility_relocations, ['planned', 'in_progress', 'completed']) }}</strong>
        <small>completed</small>
      </div>
    </div>

    <div class="toolbar">
      <select [(ngModel)]="reportType" name="reportType" (ngModelChange)="loadReport()">
        <option *ngFor="let r of reportTypes" [value]="r.id">{{ r.label }}</option>
      </select>
      <button type="button" class="btn primary sm" (click)="exportCsv()">Export CSV</button>
    </div>

    <div class="table-wrap" *ngIf="report">
      <table class="cad-table" *ngIf="report.rows.length; else noRows">
        <thead>
          <tr><th *ngFor="let c of report.columns">{{ label(c) }}</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of report.rows | slice: 0 : 50">
            <td *ngFor="let c of report.columns">{{ row[c] ?? '—' }}</td>
          </tr>
        </tbody>
      </table>
      <p class="hint" *ngIf="report.rows.length > 50">Showing first 50 of {{ report.rows.length }} rows — export CSV for all.</p>
      <ng-template #noRows><p class="empty">No rows for this report.</p></ng-template>
    </div>
  </ng-container>
</div>
